import { render } from "./ItemListGarmet.vue?vue&type=template&id=9d16de04&scoped=true"
import script from "./ItemListGarmet.vue?vue&type=script&lang=js"
export * from "./ItemListGarmet.vue?vue&type=script&lang=js"

import "./ItemListGarmet.vue?vue&type=style&index=0&id=9d16de04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d16de04"]])

export default __exports__